// ------ action constants

export const ACTION_LOCATION_SELECT = 'ACTION_LOCATION_SELECT';


export const LOCATIONS_LOADED = 'LOCATIONS_LOADED';


export const LOCATION_LOADED = 'LOCATION_LOADED';
